var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutImg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 361,
    viewBox: "0 0 360 361",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M284.523 358.645L142.924 342.219C138.518 341.708 135.084 338.143 134.75 333.716L114.999 74.6782C114.556 68.8651 119.518 64.0967 125.309 64.7636L266.907 81.19C271.314 81.7008 274.747 85.2662 275.081 89.693L294.834 348.723C295.277 354.536 290.315 359.304 284.525 358.637L284.523 358.645Z",
    stroke: "#AFA6FF",
    strokeWidth: 0.829608,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M284.121 359.087L142.523 342.661C138.116 342.15 134.683 338.585 134.349 334.158L114.598 75.1201C114.155 69.307 119.117 64.5386 124.907 65.2055L266.506 81.6319C270.912 82.1427 274.346 85.7081 274.68 90.1349L294.433 349.164C294.876 354.978 289.914 359.746 284.123 359.079L284.121 359.087Z",
    fill: "#E8E7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.486 77.7972C224.998 69.3642 230.155 50.992 222.004 36.7617C213.853 22.5314 195.48 17.8317 180.968 26.2647C166.456 34.6977 161.299 53.0699 169.45 67.3002C177.601 81.5305 195.974 86.2302 210.486 77.7972Z",
    fill: "#F47077"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.517 41.851C185.751 41.8535 185.963 41.9784 186.079 42.181L195.269 58.2169L194.099 58.9253L185.451 43.8339L175.608 59.0124L174.486 58.279L184.934 42.1685C185.063 41.9686 185.284 41.8485 185.517 41.851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.115 41.9225C195.348 41.925 195.561 42.0498 195.677 42.2524L204.867 58.2883L203.697 58.9968L195.048 43.9054L185.205 59.0839L184.084 58.3505L194.531 42.24C194.661 42.04 194.882 41.9199 195.115 41.9225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.022 42.0489L216.12 41.9657L216.093 43.4021L194.995 43.4852L195.022 42.0489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.554 45.8992L216.732 45.8238L216.705 47.2538L197.527 47.3291L197.554 45.8992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.403 49.7469L217.384 49.6764L217.357 51.1023L199.376 51.1728L199.403 49.7469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.384 49.8005L217.218 58.8456L215.955 58.8507L216.121 49.8056L217.384 49.8005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.3 58.7986L203.798 58.8511L203.825 57.4405L217.327 57.388L217.3 58.7986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.822 62.1777C223.822 62.1777 216.838 80.2222 193.196 103.793C171.862 78.4559 167.178 60.363 167.178 60.363L223.82 62.1858L223.822 62.1777Z",
    fill: "#F47077"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M190.877 218.55C190.877 218.55 156.416 229.233 146.397 236.142C136.378 243.051 160.689 344.771 160.689 344.771L269.917 357.445C269.917 357.445 270.669 258.284 269.678 248.906C268.687 239.528 215.394 215.07 215.394 215.07L198.122 215.037L190.875 218.558L190.877 218.55Z",
    fill: "#AFA6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M269.563 248.342C269.563 248.342 284.981 298.63 284.121 359.087L269.911 357.435L269.555 248.34L269.563 248.342Z",
    fill: "#AFA6FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M266.53 269.663L269.912 357.436",
    stroke: "#282E2F",
    strokeWidth: 0.829608,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9873 258.777C70.9873 258.777 54.4577 242.865 45.6724 234.687C42.5795 231.806 29.7486 218.886 28.4783 215.325C26.5023 209.814 40.3899 214.111 55.2711 230.277L91.64 244.685L70.9815 258.767L70.9873 258.777Z",
    fill: "#EDD6CC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9115 232.919C48.9115 232.919 34.4681 215.246 32.0011 207.817C29.5342 200.388 40.7761 208.116 46.3687 218.753L56.3682 228.2",
    fill: "#EDD6CC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3169 233.633C57.3169 233.633 44.7414 219.889 42.5814 206.891C40.4214 193.893 48.6875 204.585 53.4455 214.233L62.659 226.261C62.659 226.261 56.1766 216.125 55.0711 208.872C53.9656 201.619 61.5321 207.004 66.5614 217.628L69.2229 221.51C74.8339 225.667 92.2874 230.919 91.443 242.597L64.108 248.388L57.3111 233.623L57.3169 233.633Z",
    fill: "#EDD6CC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9854 215.352C35.9854 215.352 44.2224 227.05 47.6103 231.299",
    stroke: "#A95539",
    strokeWidth: 0.829608,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1182 212.567C44.1182 212.567 47.4296 219.922 55.2058 229.108",
    stroke: "#A95539",
    strokeWidth: 0.829608,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M145.583 237.255L109.785 284.985L96.9167 237.459L57.5955 252.371C57.5955 252.371 71.816 332.098 97.9947 340.495C124.165 348.89 160.618 302.212 160.618 302.212L145.591 237.258L145.583 237.255Z",
    fill: "#AFA6FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M109.786 284.985L118.501 311.085L112.487 281.38L109.786 284.985Z",
    fill: "#433A2E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M152.758 311.288C152.758 311.288 146.078 277.72 143.358 260.785",
    stroke: "#282E2F",
    strokeWidth: 0.829608,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M188.72 219.518L204.371 309.29L221.153 217.618L203.881 217.585L188.72 219.518Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M192.97 185.322L193.79 217.2L216.065 218.05L209.697 184.024L192.97 185.322Z",
    fill: "#EDD6CC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M193.344 200.015L193.043 188.125L206.906 193.377L193.344 200.015Z",
    fill: "#433A2E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M214.135 191.214C224.093 184.267 225.773 169.472 217.888 158.169C210.003 146.866 195.538 143.334 185.58 150.281C175.621 157.228 173.941 172.022 181.826 183.326C189.712 194.629 204.177 198.161 214.135 191.214Z",
    fill: "#EDD6CC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M208.221 143.657C208.221 143.657 224.85 141.736 222.779 169.459L209.2 151.219L208.221 143.657Z",
    fill: "#433A2E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M173.716 157.955C173.716 157.955 173.56 150.691 182.692 144.349C191.817 138.012 208.057 134.583 213.674 130.168C213.674 130.168 218.355 140.202 213.626 149.985C213.626 149.985 197.045 148.903 186.07 155.431C186.07 155.431 186.048 157.743 183.242 161.611C176.672 167.734 179.158 173.699 179.158 173.699C179.158 173.699 171.615 166.844 173.716 157.955Z",
    fill: "#433A2E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M199.458 165.658C199.458 165.658 200.89 171.083 198.193 172.559L200.432 175.805",
    stroke: "#433A2E",
    strokeWidth: 0.788127,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M193.681 167.219L193.941 170.509",
    stroke: "#433A2E",
    strokeWidth: 0.788127,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M205.534 167.664L205.787 170.952",
    stroke: "#433A2E",
    strokeWidth: 0.788127,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M195.517 177.261C195.517 177.261 196.78 179.696 200.744 179.839C204.713 179.992 205.661 177.643 205.661 177.643",
    stroke: "#433A2E",
    strokeWidth: 0.788127,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M193.575 208.932L203.881 217.585L197.483 228.548L188.72 219.518L193.575 208.932Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M203.881 217.585L213.873 206.323L221.153 217.618L212.89 228.614L203.881 217.585Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M203.882 217.585L199.516 225.03L203.102 229.375L199.34 280.466L204.371 309.289L209.764 279.806L205.785 229.424L208.99 223.841L203.882 217.585Z",
    fill: "#6840FD"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M295.594 133.117L291.466 139.93C289.187 143.691 278.102 141.15 266.699 134.247C264.239 132.755 261.963 131.183 259.931 129.599L267.941 116.372L295.594 133.117Z",
    fill: "#EDCA76"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M250.195 114.94L254.322 108.127L267.948 116.382L259.938 129.609C252.567 123.847 248.406 117.897 250.193 114.948L250.195 114.94Z",
    fill: "#E5B15F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M295.581 133.108C297.859 129.345 290.465 120.701 279.067 113.801C267.67 106.901 256.583 104.358 254.305 108.121C252.027 111.883 259.421 120.527 270.818 127.427C282.216 134.328 293.303 136.871 295.581 133.108Z",
    fill: "#E5B15F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M292.53 130.889C294.348 127.886 288.021 120.73 278.398 114.905C268.776 109.08 259.502 106.791 257.685 109.794C255.867 112.796 262.194 119.952 271.816 125.778C281.439 131.603 290.713 133.891 292.53 130.889Z",
    fill: "#EDCA76"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M276.784 115.392C276.66 115.599 276.991 116.031 277.528 116.364C278.068 116.689 278.608 116.791 278.734 116.575C278.861 116.36 278.528 115.936 277.99 115.603C277.452 115.27 276.91 115.176 276.784 115.392Z",
    fill: "#E5B15F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M271.914 123.44C271.789 123.647 272.12 124.079 272.658 124.412C273.198 124.737 273.74 124.831 273.864 124.623C273.988 124.416 273.657 123.984 273.119 123.651C272.582 123.318 272.038 123.232 271.914 123.44Z",
    fill: "#E5B15F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M289.04 134.719L284.913 141.532",
    stroke: "#E5B15F",
    strokeWidth: 0.207402,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M281.438 132.674L277.308 139.495",
    stroke: "#E5B15F",
    strokeWidth: 0.207402,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M273.744 129.109L269.615 135.93",
    stroke: "#E5B15F",
    strokeWidth: 0.207402,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M266.45 124.698L262.38 131.423",
    stroke: "#E5B15F",
    strokeWidth: 0.207402,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M276.653 118.251L283.516 124.916L274.518 121.922L267.898 115.055L276.653 118.251Z",
    fill: "#E5B15F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M293.29 159.726L295.573 167.363C296.83 171.582 287.502 178.092 274.731 181.902C271.977 182.727 269.284 183.354 266.743 183.798L262.321 168.983L293.288 159.734L293.29 159.726Z",
    fill: "#EDCA76"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M249.342 181.171L247.059 173.534L262.324 168.975L266.745 183.79C257.53 185.392 250.321 184.474 249.334 181.169L249.342 181.171Z",
    fill: "#E5B15F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M272.45 174.261C285.216 170.448 294.545 163.94 293.286 159.726C292.028 155.511 280.658 155.186 267.891 158.999C255.125 162.812 245.796 169.32 247.055 173.534C248.313 177.749 259.683 178.074 272.45 174.261Z",
    fill: "#E5B15F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M250.572 172.156C251.578 175.518 261.131 175.638 271.905 172.419C282.679 169.199 290.603 163.858 289.605 160.499C288.599 157.138 279.047 157.017 268.273 160.237C257.498 163.457 249.574 168.797 250.572 172.156Z",
    fill: "#EDCA76"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M267.528 161.764C267.594 161.996 268.149 162.042 268.748 161.859C269.354 161.678 269.789 161.339 269.714 161.104C269.64 160.87 269.093 160.826 268.494 161.009C267.888 161.19 267.453 161.529 267.528 161.764Z",
    fill: "#E5B15F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M270.222 170.783C270.289 171.015 270.843 171.061 271.442 170.878C272.049 170.697 272.483 170.358 272.409 170.123C272.342 169.89 271.787 169.845 271.189 170.028C270.582 170.209 270.148 170.548 270.222 170.783Z",
    fill: "#E5B15F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M290.077 165.659L292.351 173.294",
    stroke: "#E5B15F",
    strokeWidth: 0.207402,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M283.455 169.922L285.737 177.559",
    stroke: "#E5B15F",
    strokeWidth: 0.207402,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M275.646 173.232L277.929 180.869",
    stroke: "#E5B15F",
    strokeWidth: 0.207402,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M267.485 175.675L269.735 183.209",
    stroke: "#E5B15F",
    strokeWidth: 0.207402,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M269.555 163.784L279.098 163.172L270.841 167.831L261.314 168.129L269.555 163.784Z",
    fill: "#E5B15F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M108.693 189.984L148.768 193.413L149.158 208.659L109.281 205.069L108.693 189.984Z",
    fill: "#CAC4FB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M140.324 199.155L141.197 214.394L151.109 215.289L150.719 200.042L140.324 199.155Z",
    fill: "#6840FD"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M108.767 225.32L110.353 234.626L132.317 235.899L130.368 226.281L108.767 225.32Z",
    fill: "#BEB1FE"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M149.694 162.647L147.033 152.031C151.224 148.155 154.078 143.114 154.875 137.35C156.919 122.575 144.71 108.68 127.606 106.321C110.505 103.955 94.9848 114.019 92.9412 128.794C90.8976 143.569 103.106 157.464 120.21 159.823C127.307 160.805 134.121 159.642 139.822 156.893L149.688 162.637L149.694 162.647Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M152.062 167.404L149.401 156.788C153.591 152.913 156.445 147.871 157.242 142.107C159.286 127.332 147.077 113.437 129.973 111.078C112.872 108.712 97.352 118.776 95.3084 133.551C93.2648 148.326 105.474 162.221 122.577 164.58C129.675 165.562 136.488 164.399 142.189 161.65L152.056 167.394L152.062 167.404Z",
    stroke: "#E5B15F",
    strokeWidth: 0.414804,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M234.314 317.708L300.018 327.515L300.653 335.466L234.749 325.477L234.314 317.708Z",
    fill: "#CAC4FB"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M237.095 312.329L302.807 322.138L303.434 330.088L237.538 320.101L237.095 312.329Z",
    fill: "#6840FD"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M287.785 319.899L288.232 327.783L237.538 320.1L237.096 312.329L287.785 319.899Z",
    fill: "#CAC4FB"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M247.052 229.557L248.248 243.078L280.469 244.531L279.567 231.071L247.052 229.557Z",
    fill: "#CAC4FB"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M257.375 220.59L258.576 234.121L290.8 235.567L289.895 222.115L257.375 220.59Z",
    fill: "#BEB1FE"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M257.674 223.926C257.674 223.926 265.56 227.894 273.962 234.809L258.577 234.113L257.674 223.926Z",
    fill: "#CAC4FB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M263.799 240.717L265.259 252.351L276.092 253.081L274.761 241.413L263.799 240.717Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M288.57 180.294L289.692 184.889L305.842 184.716L304.912 180.206L288.57 180.294Z",
    fill: "#BEB1FE"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M297.95 171.281L298.975 175.884L303.162 176.19L302.354 171.671L297.95 171.281Z",
    fill: "#6840FD"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M143.617 116.513C143.079 121.901 139.792 127.071 135.233 131.432C130.72 135.797 124.647 139.745 118.92 142.156C113.586 138.584 108.481 133.737 104.925 128.509C101.329 123.232 99.2403 117.525 99.7781 112.137C100.176 108.147 101.688 105.52 103.78 103.907C105.817 102.277 108.436 101.753 111.068 102.016C113.65 102.319 116.042 103.503 117.985 105.427C119.889 107.291 121.31 109.789 121.857 112.724C122.862 109.944 124.752 107.731 127.043 106.286C129.278 104.835 131.862 104.103 134.595 104.376C137.327 104.648 139.747 105.675 141.421 107.675C143.096 109.675 144.014 112.534 143.616 116.524L143.617 116.513Z",
    fill: "#9747FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutImg5);
export default __webpack_public_path__ + "static/media/about_img5.1dce747767c263ca9d26a369d34bf079.svg";
export { ForwardRef as ReactComponent };